export default __webpack_public_path__ + "static/media/in-progress.01ea9589.svg";